import React from 'react';

const ParameterTableDesc = ({ title, parameters }) => {
    return (
        <div className={title ? 'mb-6' : ''}>
            {title ? (
                <div className="mb-3">
                    <h3 className="text-lg sm:text-xl font-semibold text-slate-900 dark:text-slate-100 tracking-tight">{title}</h3>
                </div>
            ) : null}
            <div className="overflow-x-auto">
                <table className="min-w-full bg-white border border-slate-200/90 rounded-2xl overflow-hidden dark:bg-slate-900/40 dark:border-slate-700/70">
                    <thead>
                    <tr className="bg-slate-50/80 dark:bg-slate-900/60">
                        <th className="px-4 py-3 text-left text-[11px] font-semibold text-slate-500 uppercase tracking-[0.18em] dark:text-slate-400">Événement</th>
                        <th className="px-4 py-3 text-left text-[11px] font-semibold text-slate-500 uppercase tracking-[0.18em] dark:text-slate-400">Description</th>
                    </tr>
                    </thead>
                    <tbody className="divide-y divide-slate-200/80 dark:divide-slate-700/60">
                    {parameters.map((param, index) => (
                        <tr key={index} className="hover:bg-slate-50/70 transition-colors dark:hover:bg-slate-800/35">
                            <td className="px-4 py-3">
                                <code className="text-[13px] font-mono text-amber-800 bg-amber-50 px-2.5 py-1 rounded-full border border-amber-200/70 dark:text-amber-200 dark:bg-amber-500/10 dark:border-amber-400/25">
                                    {param.name}
                                </code>
                            </td>
                            <td className="px-4 py-3 text-[13px] text-slate-700 dark:text-slate-200 leading-relaxed">{param.type}</td>
                        </tr>
                    ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default ParameterTableDesc;